import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { AttachmentM024DTO, M024CopyPrevDTO, M024CreationOptionsDTO, M024DetailDTO, M024OtherDetailDTO, M024ResponseOptionsDTO, M024UpdateOptionsDTO } from "./dataService/dto";
import { NewAssigmentService } from "../../incarichi/dataservice/service";
import { NewM024Service } from "./dataService/service";

interface M024State {
    // REQUEST
    m024SelectId: string

    M024Attachments: AttachmentM024DTO[]
    activeM024DetailsUpdateRequest: M024DetailDTO[]
    activeM024DetailNoAttachsUpdateRequest: M024OtherDetailDTO[]
    m024CreationRequest: M024CreationOptionsDTO
    m024UpdateRequest: M024UpdateOptionsDTO
    m024OptionsResponse: M024ResponseOptionsDTO
    //status
    M024CreationStatus: PromiseStatuses
    M024UpdateStatus: PromiseStatuses
    getAllM024Status: PromiseStatuses
    M024DeleteStatus: PromiseStatuses
}

const initialState: M024State = {
    // REQUEST
    m024SelectId: '',
    M024Attachments: [],
    m024OptionsResponse: {},
    activeM024DetailsUpdateRequest: [],
    activeM024DetailNoAttachsUpdateRequest: [],
    m024CreationRequest: {},
    m024UpdateRequest: {},
    getAllM024Status: 'idle',
    M024CreationStatus: 'idle',
    M024UpdateStatus: 'idle',
    M024DeleteStatus: 'idle'
}

export const m024Creation = createAsyncThunk(
    'm024/Creation',
    async (data: M024CreationOptionsDTO, thunkApi): Promise<M024ResponseOptionsDTO> => {
        const M024Service = NewM024Service()
        return M024Service.CreateM024(data).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const M024CopyPrev = createAsyncThunk(
    'm024/M024CopyPrev',
    async (data: M024CopyPrevDTO, thunkApi): Promise<void> => {
        const M024Service = NewM024Service()
        return M024Service.M024CopyPrev(data).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const Updatem024Options = createAsyncThunk(
    'm024/Updatem024Options',
    async (request: { body: M024UpdateOptionsDTO, id: string }, thunkApi): Promise<void> => {
        const M024Service = NewM024Service()
        return M024Service.Updatem024Options(request.body, request.id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

export const M024Delete = createAsyncThunk(
    'm024/M024Delete',
    async (id: string, thunkApi): Promise<void> => {
        const M024Service = NewM024Service()
        return M024Service.DeleteM024(id).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const M024Slice = createSlice({
    name: 'm024/slice',
    initialState,
    reducers: {
        // REQUEST [CREATION]
        setM024SelectedId: (state, action) => {
            state.m024SelectId = action.payload
        },
        resetM024Attachments: (state) => {
            state.M024Attachments = []
        },
        setM024Attachments: (state, action) => {
            state.M024Attachments = action.payload
        },
        //createM024
        setM024CreationDate: (state, action) => {
            state.m024CreationRequest.creationDate = action.payload
        },
        //update M024
        setM024UpdateIssueDate: (state, action) => {
            state.m024UpdateRequest.issueDate = action.payload
        },
        setM024UpdateNopDetails: (state, action) => {
            state.m024UpdateRequest.nopDetails = action.payload
        },
        setM024UpdateOtherReason: (state, action) => {
            state.m024UpdateRequest.otherReason = action.payload
        },
        setM024UpdateAdmRegularityProtocol: (state, action) => {
            state.m024UpdateRequest.admRegularityProtocol = action.payload
        },
        setM024UpdateadmConformity: (state, action) => {
            
            state.m024UpdateRequest.admConformity = action.payload
        },
        setM024UpdateRequestCertProtocol: (state, action) => {
            state.m024UpdateRequest.requestCertProtocol = action.payload
        },
        setM024UpdateCertificationDocumentM029: (state, action) => {
            state.m024UpdateRequest.certificationDocumentM029 = action.payload
        },
        setM024UpdateCertificationDocumentM014: (state, action) => {
            state.m024UpdateRequest.certificationDocumentM014 = action.payload
        }, setM024UpdateCertificationDocumentM020: (state, action) => {
            state.m024UpdateRequest.certificationDocumentM020 = action.payload
        },
        setM024UpdateCertificationDocumentM021: (state, action) => {
            state.m024UpdateRequest.certificationDocumentM021 = action.payload
        },
        setM024UpdateCertificationDocumentM023: (state, action) => {
            state.m024UpdateRequest.certificationDocumentM023 = action.payload
        },
        setM024UpdateCertificationDocumentNaqs: (state, action) => {
            state.m024UpdateRequest.certificationDocumentNaqs = action.payload
        },
        setM024UpdateCertificationDocumentNop: (state, action) => {
            state.m024UpdateRequest.certificationDocumentNop = action.payload
        },
        setM024UpdateReasonsEmissionNot: (state, action) => {
            state.m024UpdateRequest.reasonsEmissioNot = action.payload
        },
        setM024UpdateReasonsEmissionM029Request: (state, action) => {
            state.m024UpdateRequest.reasonsEmissionM029Request = action.payload
        },
        setM024UpdateReasonsEmissionM029Rev: (state, action) => {
            state.m024UpdateRequest.reasonsEmissionM029Rev = action.payload
        },
        setM024UpdateReasonsEmissionPsr: (state, action) => {
            state.m024UpdateRequest.reasonsEmissionPsr = action.payload
        },
        setM024UpdateClose: (state, action) => {
            state.m024UpdateRequest.closed = action.payload
        },
        setM024UpdateCancelRev: (state, action) => {
            state.m024UpdateRequest.cancelRev = action.payload
        },
        // REQUEST [DETAILS UPDATE]
        setUpdateActiveM024DetailsRequest: (state, action) => {
            state.activeM024DetailsUpdateRequest = action.payload
        },
        setUpdateM024ActiveDetailConformityById: (state, action) => {
            state.activeM024DetailsUpdateRequest[action.payload.index].conformityEvaluation = action.payload.data
        },
        setUpdateM024ActiveDetailRiesameById: (state, action) => {
            state.activeM024DetailsUpdateRequest[action.payload.index].riesameEvaluation = action.payload.data
        },
        setUpdateActiveM024DetailsNoAttachRequest: (state, action) => {
            state.activeM024DetailNoAttachsUpdateRequest = action.payload
        },
        resetUpdateCFActiveDetailsRequest: (state) => {
            state.activeM024DetailsUpdateRequest = []
        },
        setUpdateCFActiveDetailConformityById: (state, action) => {
            state.activeM024DetailsUpdateRequest[action.payload.index].conformityEvaluation = action.payload.data
        },
    },
    extraReducers(builder) {
        builder
            // CREATION
            .addCase(m024Creation.pending, (state) => {
                state.M024CreationStatus = 'loading'
            })
            .addCase(m024Creation.fulfilled, (state, action) => {
                state.M024CreationStatus = 'successfully'
                state.m024OptionsResponse = action.payload
            })
            .addCase(m024Creation.rejected, (state, action) => {
                state.M024CreationStatus = 'failed'
            })

            // UPDATE
            .addCase(Updatem024Options.pending, (state) => {
                state.M024UpdateStatus = 'loading'
            })
            .addCase(Updatem024Options.fulfilled, (state) => {
                state.M024UpdateStatus = 'successfully'
            })
            .addCase(Updatem024Options.rejected, (state) => {
                state.M024UpdateStatus = 'failed'
            })

            // DELETE
            .addCase(M024Delete.pending, (state) => {
                state.M024DeleteStatus = 'loading'
            })
            .addCase(M024Delete.fulfilled, (state) => {
                state.M024DeleteStatus = 'successfully'
            })
            .addCase(M024Delete.rejected, (state) => {
                state.M024DeleteStatus = 'failed'
            })
    }
})

export const {
    setM024SelectedId,
    setM024Attachments,
    resetM024Attachments,
    //creation
    setM024CreationDate,
    //update
    setM024UpdateAdmRegularityProtocol,
    setM024UpdateIssueDate,
    setM024UpdateNopDetails,
    setM024UpdateOtherReason,
    setM024UpdateRequestCertProtocol,
    setM024UpdateCertificationDocumentM014,
    setM024UpdateCertificationDocumentM020,
    setM024UpdateCertificationDocumentM021,
    setM024UpdateCertificationDocumentM023,
    setM024UpdateCertificationDocumentM029,
    setM024UpdateCertificationDocumentNaqs,
    setM024UpdateCertificationDocumentNop,
    setM024UpdateReasonsEmissionM029Request,
    setM024UpdateReasonsEmissionM029Rev,
    setM024UpdateReasonsEmissionNot,
    setM024UpdateReasonsEmissionPsr,
    setM024UpdateadmConformity,
    setM024UpdateCancelRev,
    setM024UpdateClose,
    setUpdateM024ActiveDetailConformityById,
    setUpdateM024ActiveDetailRiesameById,
    setUpdateActiveM024DetailsRequest,
    setUpdateActiveM024DetailsNoAttachRequest,
    setUpdateCFActiveDetailConformityById,
    //REQUEST

} = M024Slice.actions

export default M024Slice.reducer